export default "__VITE_ASSET__e48b0413__"